import { Component, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import { GlobalService } from '../../../helper/Services/global.service';
import { CallDealerLogEntryRequestModel } from '../../../Models/call-dealer-log-entry-requestModel';
import { OrderStatusService } from '../../../Services/orderstatus/order-status.service';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { Application } from 'projects/Autofacets-Core/src/app/utils/enums';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { environment } from 'projects/StatusTracker/src/environments/environment';

@Component({
  selector: 'app-dealer-information',
  templateUrl: './dealer-information.component.html'
})
export class DealerInformationComponent implements OnInit {
  orderInfo: any = {};
  orderData: any;
  popupCloseResult = false;
  DealerDetails: any;
  CustDetails: any;

  public polylinePath: google.maps.LatLngLiteral[] = [];
  public markerOptions: any; 
  public center: any;

  constructor(
    private orderService: OrderStatusService,
    private modalService: NgbModal,
    private gService: GlobalService,
  ) {}

  ngOnInit(): void {
    this.loadGoogleMapsScript();
    this.orderService.orderDetails.subscribe(res => {
      if (!isNullOrUndefined(res)) {
        this.orderData = res;
        this.initializeOrderInfo();
        this.initializeDealerAndCustomerDetails();
        this.getDirection();
      }
    });
  }

  initializeOrderInfo() {
    this.orderInfo.dealerName = this.orderData.dealerName;
        this.orderInfo.dealerId = this.orderData.dealerId;
        this.orderInfo.address = this.addressBuilder(this.orderData);
        this.orderInfo.telephone = this.orderData.landlineNumber;
        this.orderInfo.mobile = this.orderData.mobileNumber;
        this.orderInfo.openingHours = this.orderData.openingHours;
        this.orderInfo.cust_latitude=this.orderData.cust_latitude;
        this.orderInfo.cust_longitude=this.orderData.cust_logitude;
        this.orderInfo.latitude=this.orderData.latitude;
        this.orderInfo.longitude=this.orderData.logitude;
        this.orderInfo.country=this.orderData.country;
        this.orderInfo.cust_country=this.orderData.cust_country;
        this.orderInfo.isDealerActive=this.orderData.isDealerActive;
        this.orderInfo.openingDateTime=Utility.ConvertUTCDateToLocalTime(this.orderData.openingDateTime);
        this.orderInfo.closingDateTime=Utility.ConvertUTCDateToLocalTime(this.orderData.closingDateTime);
  }

  private addressBuilder(info: any) {
    let address = '';
    if (info.addressLine1 && info.addressLine1 !== '') {
      address += `${info.addressLine1}`;
    }

    if (info.addressLine2 && info.addressLine2 !== '') {
      address += `, ${info.addressLine2}`;
    }

    if (info.city && info.city !== '') {
      address += `, ${info.city}`;
    }

    if (info.country && info.country !== '') {
      address += `, ${info.country}`;
    }

    if (info.pinCode && info.pinCode !== '') {
      address += `, ${info.pinCode}`;
    }
    return address;
  }

  initializeDealerAndCustomerDetails() {
    this.DealerDetails = {
      dealerName: this.orderInfo.dealerName,
      latitude: this.orderInfo.latitude,
      longitude: this.orderInfo.longitude,
    };
    this.CustDetails = {
      latitude: this.orderInfo.cust_latitude,
      longitude: this.orderInfo.cust_longitude,
    };

    this.markerOptions = {
      origin: {
        label: 'C',
        infoWindow: this.getCustomerInfoWindow(),
      },
      destination: {
        label: 'D',
        infoWindow: this.getDealerInfoWindow(),
      }
    };
  }

  getCustomerInfoWindow() {
    return `<div class="infoWindowContent">
      <h3><b>Your Location</b></h3>
      ${this.CustDetails.address1 || ''}${this.CustDetails.address2 ? `, ${this.CustDetails.address2}` : ''}<br>
      ${this.CustDetails.city || ''}${this.CustDetails.state ? `, ${this.CustDetails.state}` : ''}<br>
      ${this.CustDetails.zipcode || ''}${this.CustDetails.country ? `, ${this.CustDetails.country}` : ''}
    </div>`;
  }

  getDealerInfoWindow() {
    return `<div class="infoWindowContent">
      <h3><b>Selected Dealer Location</b></h3>
      <h4>${this.DealerDetails.dealerName}</h4>
      ${this.DealerDetails.address || ''}<br>
      ${this.DealerDetails.city || ''}${this.DealerDetails.state ? `, ${this.DealerDetails.state}` : ''}<br>
      ${this.DealerDetails.pincode || ''}${this.DealerDetails.country ? `, ${this.DealerDetails.country}` : ''}
    </div>`;
  }

  showMap(Content): void {
    const modalRef = this.modalService.open(Content, {
      windowClass: 'dark-modal',
      backdrop: 'static',
      keyboard: false
    });
    
    modalRef.result.then(() => {
      // Handle modal result if needed
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
    });
  }

  CallDealerLogEntry() {
    const request: CallDealerLogEntryRequestModel = {
      dealerPhone: this.orderInfo?.telephone,
    };
    this.orderService.callDealerLogEntry(request).subscribe();
  }

  private getDismissReason(reason: any): boolean {
    return reason === ModalDismissReasons.ESC || reason === ModalDismissReasons.BACKDROP_CLICK ? false : reason;
  }

  getDirection(): void {
    const origin = { lat: this.CustDetails.latitude, lng: this.CustDetails.longitude };
    const destination = { lat: this.DealerDetails.latitude, lng: this.DealerDetails.longitude };
  }

  loadGoogleMapsScript() {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.GoogleKey}`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }
}
